export default [
  'activate_account',
  'ooba_required',
  'change_password',
  'answer_questions',
  'set_security_question'
];
